import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useHistory } from "react-router-dom";

const Inquiry = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const history = useHistory();
  const [products, setProducts] = useState([]);
  const [product_type_id, setProductType] = useState("");
  const [errors, setErrors] = useState({});

  const [productImages, setProductImages] = useState([]);
  const intialState = {
    company_name: "",
    name: "",
    address: "",
    phone: "",
    email: "",
    website: "",
    comments: "",
  };
  const [inquiry, setInquiry] = useState(intialState);

  const fetchProducts = () => {
    axios
      .post(`${BASE_URL}/api/product/get`) // your API endpoint
      .then((response) => {
        if (response.data.product.length > 0) {
          setProducts(response.data.product); // Store product data
        }
      })
      .catch((err) => {});
  };

  const fetchProductImages = () => {
    axios
      .post(`${BASE_URL}/api/product_image/get`, {
        product_id: product_type_id,
      }) // 👈 your API endpoint
      .then((response) => {
        if (response.data.product.length > 0) {
          setProductImages(response.data.product); // Store product data
        } else {
          setProductImages([]);
        }
      })
      .catch((err) => {
        // setError(err.message);
        // setLoading(false);
      });
  };

  const handleInquiryChange = ({ target }) => {
    const name = target && target.name;
    const value = target && target.value;
    setInquiry({ ...inquiry, [name]: value });
  };

  const validateInquiry = (inquiry) => {
    const errors = {};

    if (!inquiry.company_name.trim()) {
      errors.company_name = "Company name is required";
    }
    // if (!inquiry.company_message.trim()) {
    //   errors.company_message = "Company message is required";
    // }

    if (!inquiry.name.trim()) {
      errors.name = "Your name is required";
    }
    if (!inquiry.email.trim()) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(inquiry.email)) {
      errors.email = "Email format is invalid";
    }
    if (!inquiry.phone.trim()) {
      errors.phone = "Phone number is required";
    } else if (!/^[0-9]{10}$/.test(inquiry.phone)) {
      errors.phone = "Enter a valid 10-digit phone number";
    }
    // if (!inquiry.city.trim()) {
    //   errors.city = "City is required";
    // }
    // if (!inquiry.zip_code.trim()) {
    //   errors.zip_code = "Your Zip code  is required";
    // }
    if (!inquiry.address.trim()) {
      errors.address = "Your Address is required";
    }
    // if (!inquiry.fax.trim()) {
    //   errors.fax = "Your fax  is required";
    // }
    if (!inquiry.website.trim()) {
      errors.website = "Your website  is required";
    }
    if (!inquiry.comments.trim()) {
      errors.comments = "Your comments  is required";
    }

    return errors;
  };
  const handleSendMessage = (e) => {
    e.preventDefault();
    const validationErrors = validateInquiry(inquiry);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setErrors({});
    const {
      company_name,
      // company_message,
      name,
      address,
      // city,
      phone,
      email,
      // zip_code,
      // fax,
      website,
      comments,
    } = inquiry;

    const company_detail = {
      company_name,
      name,
      address,
      phone,
      email,
      website,
      comments,
    };

    axios
      .post(`${BASE_URL}/api/inquiry/create`, company_detail)
      .then((response) => {
        if (response) {
          setInquiry(intialState);
          toast.success(`Inquiry : ${comments}`);
          history.push("/");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        // Handle error (e.g., show an error message)
      });
  };

  useEffect(() => {
    fetchProducts();
    fetchProductImages();
  }, [product_type_id]);

  return (
    <>
      <main className="main-content site-wrapper-reveal">
        {/* <!--== Start Page Title Area ==--> */}
        <section
          className="page-content-area "
          data-bg-img="assets/img/photos/bg-page-title.webp"
          style={{
            backgroundImage: `url("../../assets/img/product_img_cover.jpg")`,
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-title-content text-center">
                  <h1 className="title text-white">Inquiry</h1>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="contact-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="contact-form">
                  <form
                    className="contact-form-wrapper"
                    id="contact-form"
                    onSubmit={(e) => handleSendMessage(e)} // ✅ No insecure action URL
                    autoComplete="on"
                  >
                    <div className="row">
                      <div className="col-lg-12" style={{ marginTop: "-60px" }}>
                        <div className="section-title">
                          <h2 className="title">Inquiry</h2>
                          <p>
                            There are many variations of inquiries we receive
                            every day, but your message helps us understand your
                            needs better.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-12">
                        <div className="row">
                          {/* COMPANY NAME */}
                          <div className="col-md-6">
                            <div className="form-group">
                              <div className="custom-form">
                                <input
                                  className="form-control custom-placeholder"
                                  type="text"
                                  name="company_name"
                                  placeholder="company name *"
                                  value={inquiry.company_name || ""}
                                  onChange={handleInquiryChange}
                                />
                              </div>
                              {errors.company_name && (
                                <span
                                  className="text-danger mb-10"
                                  style={{ fontSize: "12px" }}
                                >
                                  {errors.company_name}
                                </span>
                              )}
                            </div>
                          </div>

                          {/* NAME */}
                          <div className="col-md-6">
                            <div className="form-group">
                              <div className="custom-form">
                                <input
                                  className="form-control custom-placeholder"
                                  type="text"
                                  name="name"
                                  placeholder="your name *"
                                  value={inquiry.name || ""}
                                  onChange={handleInquiryChange}
                                />
                              </div>
                              {errors.name && (
                                <span
                                  className="text-danger mb-10"
                                  style={{ fontSize: "12px" }}
                                >
                                  {errors.name}
                                </span>
                              )}
                            </div>
                          </div>

                          {/* EMAIL */}
                          <div className="col-md-6">
                            <div className="form-group">
                              <div className="custom-form">
                                <input
                                  className="form-control custom-placeholder"
                                  type="email"
                                  name="email"
                                  placeholder="your email *"
                                  value={inquiry.email || ""}
                                  onChange={handleInquiryChange}
                                />
                              </div>
                              {errors.email && (
                                <span
                                  className="text-danger mb-10"
                                  style={{ fontSize: "12px" }}
                                >
                                  {errors.email}
                                </span>
                              )}
                            </div>
                          </div>

                          {/* PHONE */}
                          <div className="col-md-6">
                            <div className="form-group">
                              <div className="custom-form">
                                <input
                                  className="form-control custom-placeholder"
                                  type="text"
                                  name="phone"
                                  placeholder="phone"
                                  value={inquiry.phone || ""}
                                  onChange={handleInquiryChange}
                                  maxLength="10"
                                />
                              </div>
                              {errors.phone && (
                                <span
                                  className="text-danger mb-10"
                                  style={{ fontSize: "12px" }}
                                >
                                  {errors.phone}
                                </span>
                              )}
                            </div>
                          </div>

                          {/* ADDRESS */}
                          <div className="col-md-6">
                            <div className="form-group">
                              <div className="custom-form">
                                <input
                                  className="form-control custom-placeholder"
                                  type="text"
                                  name="address"
                                  placeholder="address"
                                  value={inquiry.address || ""}
                                  onChange={handleInquiryChange}
                                />
                              </div>
                              {errors.address && (
                                <span
                                  className="text-danger mb-10"
                                  style={{ fontSize: "12px" }}
                                >
                                  {errors.address}
                                </span>
                              )}
                            </div>
                          </div>

                          {/* WEBSITE */}
                          <div className="col-md-6">
                            <div className="form-group">
                              <div className="custom-form">
                                <input
                                  className="form-control custom-placeholder"
                                  type="text"
                                  name="website"
                                  placeholder="website"
                                  value={inquiry.website || ""}
                                  onChange={handleInquiryChange}
                                />
                              </div>
                              {errors.website && (
                                <span
                                  className="text-danger mb-10"
                                  style={{ fontSize: "12px" }}
                                >
                                  {errors.website}
                                </span>
                              )}
                            </div>
                          </div>

                          {/* COMMENTS */}
                          <div className="col-md-12">
                            <div className="form-group">
                              <div className="custom-form">
                                <textarea
                                  className="form-control textarea custom-placeholder"
                                  name="comments"
                                  placeholder="message.."
                                  rows="2"
                                  value={inquiry.comments || ""}
                                  onChange={handleInquiryChange}
                                ></textarea>
                              </div>
                              {errors.comments && (
                                <span
                                  className="text-danger mb-10"
                                  style={{ fontSize: "12px" }}
                                >
                                  {errors.comments}
                                </span>
                              )}
                            </div>
                          </div>

                          {/* SUBMIT BUTTON */}
                          <div className="col-md-12">
                            <div className="form-group mb-0">
                              <button className="btn btn-theme" type="submit">
                                SEND MESSAGE
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="form-message"></div>
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="contact-map-area pt-80">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.549603127616!2d72.55226782531432!3d23.040303829161346!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e85c1db177071:0x5e16ca356773e748!2sSachi%20Products!5e0!3m2!1sen!2sin!4v1761893806970!5m2!1sen!2sin"></iframe>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};
export default Inquiry;
